import { useQuery } from 'react-query'
import { getRisikaRefreshToken } from 'services/cm-api/get-risika-refresh-token'

export function useRisikaRefreshTokenWeb(customerId) {
  return useQuery(
    ['getRisikaRefreshToken'],
    () => getRisikaRefreshToken(customerId),
    {
      enabled: false,
    },
  )
}
